export class User {
    id?: string;
    uid?: string;
    displayName?: string;
    email?: string;

    displayEmail(){
        // censor the email address
        let censoredEmail = '';
        if(this.email){
            const address = this.email.split("@")[0];
            const handle = this.email.split("@")[1];
            // split by "." and replace all but first of each segment to "*"
            let parts = [];
            address.split(".").forEach(segment => {
                parts.push(`${segment.charAt(0)}${"*".repeat(segment.length - 1)}`)
            })
            censoredEmail = `${parts.join(".")}@${handle}`
        }
        return censoredEmail;
    }
}